import React from 'react'
import Exclamaiton from "../../../components/Svg/Exclamaiton";
import {H4} from "../../../components/typography";
import styled from "@emotion/styled";

const Container = styled.div`
    width: 100%;
    height: auto;
    text-align: left;
    border: 1px solid #ddd;
    padding: 16px;
    border-radius: 14px;
    margin: 14px auto 48px auto;
    display: inline-block;
    box-sizing: border-box;
`;

const Box = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: #727272;
    white-space: pre-wrap;
    margin: 2px 0;
    position: relative;
`;
const List = styled.ul`
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 13px;
    color: #727272;
    white-space: pre-wrap;
    padding: 0 0 0 15px;
    position: relative;
    margin: 14px auto 0px auto;
`;

const ListItem = styled.li`
    margin-bottom: 10px;
    list-style-type: disc;
    font-size: 14px;
    font-style: normal;
`;

export default function Guide() {
    return (
        <Container>
            <Box>
                <Exclamaiton style={{paddingRight: "5px"}}/>
                <H4>푸시(인증 요청)가 휴대폰으로 오지 않았다면?</H4>
            </Box>
            <List>
                <ListItem> 앱이 설치되어 있는지 확인해주세요 </ListItem>
                <ListItem> 해당 앱에 접속하여 알림 내역을 확인해주세요</ListItem>
            </List>
        </Container>
    )
}
